<template>
  <div>
    <ts-dialog title="Broadcasting rights" :visible.sync="visible" width="500px" center>
      <div>
        <ts-form-item label="Broadcasting date" class="mb-4" :validation="$v.form.startDate">
          <DatePickerDropdown
            placeholder="Pick a date"
            mode="date"
            size="normal"
            v-model="$v.form.startDate.$model"
          ></DatePickerDropdown>
        </ts-form-item>
        <ts-form-item label="Broadcasting rights" class="mb-4" :validation="$v.form.option">
          <MultiSelectionDropdown
            placeholder="Select a broadcasting right"
            size="normal"
            :max-items="1"
            :options="broadcastOptions"
            :read-only-single-option="false"
            v-model.lazy="options"
          ></MultiSelectionDropdown>
        </ts-form-item>
        <ts-form-item label="Country" :validation="$v.country" class="dropdown">
          <MultiSelectionDropdown
            placeholder="Select a country"
            :max-items="1"
            :width="378"
            size="large"
            :options="regions"
            :read-only-single-option="false"
            v-model.lazy="$v.form.country.$model"
          >
          </MultiSelectionDropdown>
        </ts-form-item>
      </div>
      <div class="flex items-center justify-between" v-if="customOptionSelected">
        <ts-form-item label="Music (in months)" class="px-2">
          <ts-input placeholder="12" v-model="form.option.music"></ts-input>
        </ts-form-item>
        <ts-form-item label="Artist (in months)" class="px-2">
          <ts-input placeholder="12" v-model="form.option.artist"></ts-input>
        </ts-form-item>
        <ts-form-item label="Actor (in months)" class="px-2">
          <ts-input placeholder="12" v-model="form.option.actor"></ts-input>
        </ts-form-item>
      </div>
      <div slot="footer" class="flex items-center justify-center">
        <div class="font-semibold">
          <ts-button class="font-semibold" :loading="loading" @click="handleSaveClick">Save</ts-button>
        </div>
      </div>
    </ts-dialog>
    <ts-button ref="shareButton" :type="buttonClass" size="small" filled @click="handleOpenDialogButtonClick">
      <strong class=""> Broadcasting rights... </strong>
    </ts-button>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DatePickerDropdown from '@/components/inputs/DatePickerDropdown.vue';
import { required } from 'vuelidate/lib/validators';
import MultiSelectionDropdown from '@/components/inputs/MultiSelectionDropdown.vue';

export default {
  components: { DatePickerDropdown, MultiSelectionDropdown },
  name: 'BroadcastingRights',
  data() {
    return {
      visible: false,
      loading: false,
      callback: null,
      broadcastOptions: [
        { id: 'standard', name: 'Standard (1 year)', artist: 12, music: 12, actor: 12 },
        { id: 'standard-2', name: 'Standard (2 years)', artist: 24, music: 24, actor: 24 },
        { id: 'custom', name: 'Custom broadcasting rights', artist: 12, music: 12, actor: 12 }
      ],
      options: ['standard'],
      url: '',
      form: {
        startDate: null,
        option: { id: 'custom', name: 'Custom broadcasting rights', artist: 12, music: 12, actor: 12 }
      }
    };
  },
  mounted() {
    this.fetchRegions();
    window.EventBus.$on('Delivery.BroadcastingRights', callback => {
      this.callback = callback;
      this.handleOpenDialogButtonClick();
    });
  },
  validations: {
    form: {
      startDate: {
        required
      },
      option: {
        music: { required },
        artist: { required },
        actor: { required }
      },
      country: {
        required
      },
      message: {}
    }
  },
  computed: {
    buttonClass() {
      return this.project && this.project.broadcastingRights ? 'primary' : 'normal';
    },
    ...mapState({
      project: state => state.workflow.currentProject.value,
      regions: state => state.workflow.regions.items.map(b => ({...b, _id: b.id, id: b.slug})),
    }),
    customOptionSelected() {
      return this.options[0] === 'custom';
    }
  },
  methods: {
    ...mapActions('workflow', ['updateProjectBroadcastingRights', 'fetchRegions']),
    handleDatesChange(event) {
      console.error(event);
    },
    handleOpenDialogButtonClick() {
      this.resetForm();
      this.init();
      this.visible = true;
    },
    init() {
      if (this.project && this.project.broadcastingRights) {
        this.options = [this.project.broadcastingRights.option.id];
        this.form.option = this.project.broadcastingRights.option;
        this.form.startDate = new Date(this.project.broadcastingRights.startDate);
      }
    },
    resetForm() {
      this.form = {
        startDate: null,
        option: { id: 'standard', name: 'Standard (1 year)', artist: 12, music: 12, actor: 12 }
      };

      this.$v.$reset();
    },
    skip() {
      this.visible = false;
      this.resetForm();
    },
    async handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.options && this.options[0] !== 'custom') {
          this.form.option = this.broadcastOptions.find(o => o.id === this.options[0]);
        } else {
          this.form.option.id = 'custom';
          this.form.option.name = 'Custom broadcasting rights';
          this.form.option.artist = parseInt(this.form.option.artist);
          this.form.option.music = parseInt(this.form.option.music);
          this.form.option.actor = parseInt(this.form.option.actor);
        }
        this.form.option.regions = parseInt(this.form.country);
        try {
          let value = { ...this.form };
          value.startDate.setHours(23, 59, 59, 999);
          await this.updateProjectBroadcastingRights({
            value,
            project: this.project
          });
          this.loading = false;
          this.skip();

          if (this.callback) {
            window.EventBus.$emit('Delivery.ShareFinalAssets');
          }
          this.callback = null;
        } catch (error) {
          this.loading = true;
        }
        // this.$emit('input', this.form);
        // this.visible = false;
        // this.resetForm();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.m-2 {
  margin: 0.5rem;
}
.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 400px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .files {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}
.flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.mb-2 {
  margin-bottom: 0.5em;
}
.flex-1 {
  flex: auto;
}
.flex-none {
  flex: none;
}
.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.justify-between {
  justify-content: space-between;
}
.cursor-pointer {
  cursor: pointer;
}
</style>